module.exports = __webpack_public_path__ + "images/eae9e22665cd0bd1fb0e96da272f948e.svg";